module.exports = __webpack_public_path__ + "static/4-7751e9ddace45719005d811e9c96d06a.jpg";